import { createContext } from 'react'

const UserThemeContext = createContext()

export default UserThemeContext
